import secureLocalStorage from "react-secure-storage";
import React, { useState, useRef } from "react";
import IdleTimer from "react-idle-timer";
import { Popup } from "@progress/kendo-react-popup";

function IdleTimerContainer() {
  const [modalIsOpen, setModalOpen] = useState(false);
  const sessionTimeoutRef=useRef(null);
  const idleTimerRef = useRef(null);
  const onIdle = () => {
    if (secureLocalStorage.getItem("loginUserId")) {
      setModalOpen(true);
    }
    
    sessionTimeoutRef.current=setTimeout(logout,30000);
  };

  const stayActive = () => {
    setModalOpen(false);
    clearTimeout(sessionTimeoutRef.current);
  };
  const logout = () => {
    setModalOpen(false);
    clearTimeout(sessionTimeoutRef.current);
   
    let userKey = secureLocalStorage.getItem("userKey");
    let user = secureLocalStorage.getItem("loggedClient")?secureLocalStorage.getItem("loggedClient"):'tenant';
    userKey=userKey?userKey:secureLocalStorage.getItem("tenantKey");
    window.location.href=`/${user}/${userKey}`;
  };
  return (
    <div>
      <IdleTimer
        ref={idleTimerRef}
        timeout={1000 * 60 * 90}
        onIdle={onIdle}
        // crossTab={true}
      ></IdleTimer>

      <Popup show={modalIsOpen} popupClass={"popup-content"}>
        <div className="deleteModelCont">
          <h3>Session time out, Do you want to continue?</h3>
          <div className="btnCont">
            <button onClick={logout} className="deleteBtn" type="button">
              Log me out
            </button>
            <button onClick={stayActive} className="cancelBtn" type="button">
              Keep me signed in
            </button>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default IdleTimerContainer;
